// 公欠申請の「参加証明書」「就職活動用紙」PDF生成。PDF自体の組み立てはCloud Functions側
// (functions/absenceRequestPdf.js)で行い、ここではその呼び出しだけを担う。

import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

const REGION = 'asia-northeast1';

export type AbsenceRequestPdfType = 'certificate' | 'activitySheet';

export async function generateAbsenceRequestPdf(
  requestId: string,
  docType: AbsenceRequestPdfType,
): Promise<{ downloadUrl: string }> {
  const fns = getFunctions(getApp(), REGION);
  const call = httpsCallable(fns, 'generateAbsenceRequestPdf', { timeout: 60000 });
  const res = await call({ requestId, docType });
  return res.data as { downloadUrl: string };
}
